class Authentication {
  constructor() {
    this.token = null;
    this.expiry = null;
    this.type = null;
  }

  isLoggedIn() {
    return this.token && this.expiry && this.type;
  }

  getToken() {
    return this.token;
  }

  loggedIn(token, expiry, type) {
    this.token = token;
    this.expiry = expiry;
    this.type = type;
  }

  logout() {
    this.token = null;
    this.expiry = null;
    this.type = null;
  }
}

const Auth = new Authentication();

export default Auth;
